export default __webpack_public_path__ + "static/universlt-roman-e4b1229605d9bc36e8ede6d321a4b673.woff";